import Element from "../../element";

export default class PhotoInput extends Element {
	constructor(props) {
		super(props);

		this.$fileInput = null;
		this.$fileName = null;

		this.fileTypes = props.filetypes || ['image/png', 'image/jpg', 'image/jpeg'];
		this.value = null;

		this.VALUE_CHANGE_EVENT = 'valueChange';

		this.init();
	}

	init() {
		if (this.$root == null) {
			throw new Error('PhotoInput: Root element is not defined!');
		}

		if (!Array.isArray(this.fileTypes)) {
			throw new Error('PhotoInput: filtypes prop must be an array of strings.');
		}

		this.$fileInput = this.$root.querySelector('.photo-input_file-input');
		this.$fileName = this.$root.querySelector('.photo-input_file');

		super.init();
	}

	addEventListeners() {
		const fileReader = new FileReader();
		fileReader.addEventListener('loadend', () => {
			const base64 = fileReader.result.replace(/^data:.+;base64,/, '');
			this.setValue(base64);
		});

		this.$fileInput.addEventListener('change', (e) => {
			const file = this.$fileInput.files[0];

			if (file == null) {
				return;
			}

			const sizeMb = file.size / 1024 / 1024;

			if (!this.fileTypes.includes(file.type) || sizeMb > 10) {
				this.dropState();
				return;
			}

			fileReader.readAsDataURL(file);
			this.$fileName.textContent = file.name;
		});
	}

	setValue(value) {
		this.value = value;
		this.dispatchEvent(this.VALUE_CHANGE_EVENT, this.value);
	}

	dropState() {
		this.$fileInput.value = '';
		this.$fileName.textContent = '';
		this.setValue(null);
	}
}